import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButtonRegular as TextButton } from '@xingternal/malt-button';
import Image from '@xingternal/malt-image';
import {
  IconShapeCircleTick,
  IconShapeCrossCircle,
} from '@xingternal/malt-icon';

import ModalInfo from './../../../Components/ModalInfo/ModalInfo';
import { CustomH } from './../../../Components/CustomMalt/Typography';

import messages from './messages';
import styles from './FileUploadStep.css';
import imageIdPerfect from './images/id_perfect.png';
import imageIdBackside from './images/id_backside.png';
import imageIdBlurry from './images/id_blurry.png';
import imageIdCutaway from './images/id_cutaway.png';
import imageIdUpsideDown from './images/id_upside_down.png';

const renderImageDescription = iconsWithLabelProps => (
  <div className={styles.imageDescription}>
    {iconsWithLabelProps.map(({ color, message }) => {
      const Icon =
        color === 'green' ? IconShapeCircleTick : IconShapeCrossCircle;

      return (
        <div className={styles.iconWithLabel} key={message.id}>
          <Icon className={styles[`icon-${color}`]} size={20} />
          <FormattedMessage {...message} />
        </div>
      );
    })}
  </div>
);

const FileUploadHowToModal = () => (
  <ModalInfo>
    {(openModal, renderModalContent) => (
      <>
        <TextButton onClick={openModal} className={styles.centerItem}>
          <FormattedMessage {...messages.fileUploadHowTo} />
        </TextButton>
        {renderModalContent(
          <>
            <CustomH>
              <FormattedMessage {...messages.fileUploadHowToLikeSo} />
            </CustomH>

            <Image src={imageIdPerfect} className={styles.image} />
            {renderImageDescription([
              { color: 'green', message: messages.fileUploadHowToReadable },
              {
                color: 'green',
                message: messages.fileUploadHowToSharp,
              },
            ])}

            <CustomH>
              <FormattedMessage {...messages.fileUploadHowToNoNo} />
            </CustomH>

            <Image src={imageIdUpsideDown} className={styles.image} />
            {renderImageDescription([
              {
                color: 'red',
                message: messages.fileUploadHowToUpsideDown,
              },
            ])}

            <Image src={imageIdBlurry} className={styles.image} />
            {renderImageDescription([
              {
                color: 'red',
                message: messages.fileUploadHowToBlurry,
              },
            ])}

            <Image src={imageIdBackside} className={styles.image} />
            {renderImageDescription([
              {
                color: 'red',
                message: messages.fileUploadHowToBackside,
              },
            ])}

            <Image src={imageIdCutaway} className={styles.image} />
            {renderImageDescription([
              {
                color: 'red',
                message: messages.fileUploadHowToCovered,
              },
              {
                color: 'red',
                message: messages.fileUploadHowToCutaway,
              },
            ])}
          </>
        )}
      </>
    )}
  </ModalInfo>
);

export default FileUploadHowToModal;
